import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <footer className='footer'>
            Copyright &#169; 2023 Karli AM. All rights reserved.
        </footer>
    );
}

export default Footer;